<template>
  <div class="dropdown">
    <button
      class="dropdown-toggle d-flex justify-content-between align-items-center w-100"
      type="button"
      id="program-select-btn-1"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span class="placeholder" ref="placeholder">{{ placeholderCopy }}</span><img src="/images/icon_caret-down.png" class="arrow" alt="">
    </button>

    <div class="dropdown-menu w-100" aria-labelledby="program-select-btn-1">
      <div class="d-flex flex-column align-items-start">
        <button
          v-for="(i, index) in data"
          :key="index"
          @click="sendDropdownEvent($event)"
          @keydown.Enter="sendDropdownEvent($event)"
          :class="`${type}-level option w-100`"
          :data-type="`${type}`"
          :data-level="i.level"
          :data-shows-partner-levels="i.showsPartnerLevels ? i.showsPartnerLevels : ''"
          :id="i.level"
        >
          {{ i.title }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  id: [String, Number],
  data: [Array],
  placeholder: [String],
  type: [String],
  selectedLevel: [Array],
});

const emit = defineEmits(['dropdown-event']);
const sendDropdownEvent = (e) => emit('dropdown-event', e);

const placeholderCopy = computed(() => {
  if (props.selectedLevel.length) {
    return props.selectedLevel[0].title;
  } else {
    return props.placeholder;
  }
});
</script>
